import { useEffect, useState } from "react";

const getResponsiveMode = (width) => {
  if (width < 768) return "phone";
  if (width < 1024) return "tablet";
  return "desktop";
};

const getViewportState = () => {
  if (typeof window === "undefined") {
    return { width: 1280, mode: "desktop" };
  }

  const width = window.innerWidth;
  return { width, mode: getResponsiveMode(width) };
};

const useResponsiveMode = () => {
  const [viewport, setViewport] = useState(getViewportState);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const handleResize = () => {
      setViewport(getViewportState());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    width: viewport.width,
    mode: viewport.mode,
    isPhone: viewport.mode === "phone",
    isTablet: viewport.mode === "tablet",
    isDesktop: viewport.mode === "desktop",
    isMobile: viewport.mode !== "desktop",
  };
};

export default useResponsiveMode;
